"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _index = require("../../index");

var _StackedDrawer = require("../../StackedDrawer");

var _index2 = require("../index");

var _CloseButton = _interopRequireDefault(require("../CloseButton"));

var _index3 = require("./index.styles");

var _excluded = ["title", "closeButtonLabel"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Header = function Header(_ref) {
  var title = _ref.title,
      closeButtonLabel = _ref.closeButtonLabel,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var drawerStack = (0, _index.useDrawerStack)();
  /* eslint-disable react-hooks/rules-of-hooks */
  // Disabled so Drawer.Header can be used both within Drawer and StackedDrawer

  var _ref2 = drawerStack ? (0, _react.useContext)(_StackedDrawer.StackedDrawerContext) : (0, _react.useContext)(_index2.DrawerContext),
      close = _ref2.close;
  /* eslint-enable */


  return /*#__PURE__*/_react["default"].createElement(_index3.StyledHeader, props, /*#__PURE__*/_react["default"].createElement(_index3.StyledTitle, null, title), /*#__PURE__*/_react["default"].createElement(_CloseButton["default"], {
    onClick: close,
    "data-testid": "close-button",
    "aria-label": closeButtonLabel,
    title: closeButtonLabel
  }));
};

Header.propTypes = {
  title: _propTypes.string,
  closeButtonLabel: _propTypes.string
};
Header.defaultProps = {
  closeButtonLabel: 'Close'
};
var _default = Header;
exports["default"] = _default;